import React, { useState } from "react";
import { Button, Card, Checkbox, Input } from "antd";
import { useNavigate } from "react-router-dom";
import message from "../../components/Message";
import "./index.css";

export default function LoginModule() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [rememberAccount, setRememberAccount] = useState(false);
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8080";

  const onFinish = async () => {
    if (loading) return;
    if (!account.trim()) {
      message.toast("请输入账号");
      return;
    }
    if (!password.trim()) {
      message.toast("请输入密码");
      return;
    }
    setLoading(true);
    try {
      const params = new URLSearchParams({
        account,
        password,
      });
      const resp = await fetch(`${baseUrl}/admin/loginByAccount?${params}`);
      const result = await resp.json();
      const { code, msg } = result || {};
      if (code) {
        message.toast(msg || "登录失败");
        return;
      }
      const { admin, token } = result.data || {};
      if (admin && token) {
        localStorage.setItem("admin", JSON.stringify(admin));
        localStorage.setItem("token", token);
      }
      navigate("/", { replace: true });
    } catch (error) {
      message.toast("登录失败");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div style={{ minHeight: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Card
        title={<div style={{ textAlign: "center", width: "100%" }}>WADesktop多商管理</div>}
        style={{ width: 360 }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <div style={{ marginBottom: 6, fontSize: 14, color: "#374151" }}>
              <span style={{ color: "#ef4444", marginRight: 4 }}>*</span>
              账号
            </div>
            <Input
              placeholder="请输入账号"
              autoComplete="off"
              value={account}
              onChange={(event) => setAccount(event.target.value)}
              onPressEnter={onFinish}
            />
          </div>
          <div>
            <div style={{ marginBottom: 6, fontSize: 14, color: "#374151" }}>
              <span style={{ color: "#ef4444", marginRight: 4 }}>*</span>
              密码
            </div>
            <Input.Password
              placeholder="请输入密码"
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              onPressEnter={onFinish}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 2 }}>
            <Checkbox checked={rememberAccount} onChange={(event) => setRememberAccount(event.target.checked)}>
              记住账号
            </Checkbox>
            <span
              role="button"
              tabIndex={0}
              onClick={() => message.toast("请联系WADesktop平台")}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  message.toast("请联系WADesktop平台");
                }
              }}
              style={{ color: "#2563eb", cursor: "pointer" }}
            >
              忘记密码
            </span>
          </div>
          <Button
            type="primary"
            block
            loading={loading}
            onClick={onFinish}
            size="large"
            style={{ marginTop: 6, marginBottom: 6 }}
          >
            登录
          </Button>
        </div>
      </Card>
    </div>
  );
}
